module.exports = __webpack_public_path__ + "img/author1.png";